import styled from "styled-components";
import { colors } from "../contants";
import { GoMail } from "react-icons/go";
import { BsInstagram } from "react-icons/bs";
import { FiPhone, FiMapPin } from "react-icons/fi";

export const Cont = styled.div`
  padding: clamp(3.5rem, 8vw, 5rem) 1.5rem clamp(2.5rem, 6vw, 3.5rem);
  background-color: rgb(40, 40, 50);
`;

export const FooterContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(280px, 420px) minmax(280px, 600px);
  gap: clamp(2.5rem, 6vw, 5rem);
  justify-content: center;
  align-items: start;
  max-width: 1120px;
  margin: 0 auto;

  @media only screen and (max-width: 800px) {
    grid-template-columns: 1fr;
    justify-items: center;
    text-align: center;
  }
`;

export const IconBox = styled.div`
  width: 15rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 2rem;
`;

export const IconButton = styled.button`
  width: 3rem;
  height: 3rem;
  border-radius: 5px;
  background-color: green;
  &:hover {
    background-color: ${colors.secondaryColor};
  }
`;

export const FooterLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  width: 100%;

  @media only screen and (max-width: 800px) {
    align-items: center;
    text-align: center;
  }
`;

export const FooterRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.9rem;

  &:not(:first-child) {
    margin-top: 1.25rem;
  }
`;

export const IconWrap = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: white;
  font-size: 1.1rem;
`;

export const FooterText = styled.h3`
  color: white;
  font-size: 1.3rem;
  @media only screen and (max-width: 600px) {
    font-size: 1rem;
  }
`;

export const FooterText2 = styled.h3`
  color: white;
  font-size: 1.6rem;
  @media only screen and (max-width: 600px) {
    font-size: 1rem;
  }
`;

export const FooterImg = styled.img`
  width: 6.5rem;
  margin-bottom: 2rem;
`;

export const ContactInfo = styled.p`
  color: rgba(255, 255, 255, 0.85);
  font-size: 1.05rem;
  margin: 0;
  display: flex;
  align-items: center;
`;

export const StyledLink = styled.a`
  text-decoration: none;
  color: inherit;
  &:hover {
    text-decoration: underline;
  }
`;

export const PhoneIcon = styled(FiPhone)`
  font-size: 1.5rem;
  margin-right: 1rem;
  fill: white;
`;

export const EmailIcon = styled(GoMail)`
  font-size: 1.5rem; /* Adjust the icon size as needed */
  margin-right: 1rem; /* Add spacing between the icon and email address */
  fill: white;
`;

export const LocationIcon = styled(FiMapPin)`
  font-size: 1.5rem; /* Adjust the icon size as needed */
  margin-right: 1rem; /* Add spacing between the icon and email address */
  fill: white;
`;

export const instagramIcon = styled(BsInstagram)`
  font-size: 1.5rem; /* Adjust the icon size as needed */
  margin-right: 1rem; /* Add spacing between the icon and email address */
  fill: white !important;
`;

export const GoogleMapContainer = styled.div`
  width: 100%;
  max-width: 600px;
  aspect-ratio: 4 / 3;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.12);

  iframe {
    width: 100%;
    height: 100%;
    border: 0;
    display: block;
  }
`;

export const FooterTitle = styled.h2`
  color: white;
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  position: relative;
  padding-bottom: 1rem;

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    width: 56px;
    height: 3px;
    background: ${colors.gold};
    border-radius: 2px;
  }
`;

export const titleRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 3rem;
`;
